import React from 'react'

const LineHead = () => {
  return (
    <div className="flex flex-row justify-between mt-10 font-bold">
      <div className="w-1/3">Name</div>
      <div className="w-1/6">Quantity</div>
      <div className="w-2/6 text-right">Unit Price</div>
      <div className="w-1/6 text-right">Net Cost</div>
    </div>
  )
}

export default LineHead
